export const GP_ACCESS_TOKEN_COOKIE = 'gp_at';
export const GP_ACCESS_VERIFICATION_COOKIE = 'gp_at_verify';

/**
 * The PKCE login state, set by keycloakLoginRedirect() and consumed by the
 * server plugin's code exchange.
 */
export type AccessVerificationCookie = {
  state: string;
  code_verifier: string;
  /** The full path to return to, query included. Absent on cookies set before it existed. */
  return_to?: string;
};

export default {};
